import React, { useState } from 'react'
import PropTypes from 'prop-types'

const presetColors = [
  '#2563eb', // Blue
  '#10b981', // Green
  '#f59e0b', // Amber
  '#ec4899', // Pink
  '#8b5cf6', // Purple
  '#ef4444', // Red
  '#06b6d4', // Cyan
  '#84cc16', // Lime
]

function ColorPicker({ color, onColorChange }) {
  const [showPicker, setShowPicker] = useState(false)
  const [customColor, setCustomColor] = useState(color)

  const handleColorSelect = (selectedColor) => {
    onColorChange(selectedColor)
    setShowPicker(false)
  }

  const handleCustomColorChange = (e) => {
    const newColor = e.target.value
    setCustomColor(newColor)
    if (/^#[0-9A-F]{6}$/i.test(newColor)) {
      onColorChange(newColor)
    }
  }

  return (
    <div className="relative">
      {/* Color preview */}
      <div
        className="w-12 h-12 rounded-lg border-2 border-gray-300 cursor-pointer hover:border-gray-400 transition-colors"
        style={{ backgroundColor: color }}
        onClick={() => setShowPicker(!showPicker)}
      ></div>

      {/* Color picker dropdown */}
      {showPicker && (
        <div className="absolute top-full left-0 mt-2 bg-white rounded-lg shadow-lg border p-4 z-10 min-w-[200px]">
          <div className="mb-3">
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Color personalizado
            </label>
            <div className="flex items-center space-x-2">
              <input
                type="color"
                value={customColor}
                onChange={handleCustomColorChange}
                className="w-10 h-10 rounded border border-gray-300 cursor-pointer"
              />
              <input
                type="text"
                value={customColor}
                onChange={handleCustomColorChange}
                className="form-input flex-1"
                placeholder="#2563eb"
              />
            </div>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Colores predefinidos
            </label>
            <div className="grid grid-cols-4 gap-2">
              {presetColors.map((presetColor) => (
                <button
                  key={presetColor}
                  className={`w-8 h-8 rounded border-2 hover:scale-110 transition-transform ${
                    color === presetColor ? 'border-gray-800' : 'border-gray-300'
                  }`}
                  style={{ backgroundColor: presetColor }}
                  onClick={() => handleColorSelect(presetColor)}
                  title={presetColor}
                ></button>
              ))}
            </div>
          </div>

          <div className="mt-3 pt-3 border-t">
            <button
              onClick={() => setShowPicker(false)}
              className="w-full py-2 px-3 bg-gray-100 text-gray-700 rounded hover:bg-gray-200 transition-colors text-sm"
            >
              Cerrar
            </button>
          </div>
        </div>
      )}

      {/* Click outside to close */}
      {showPicker && (
        <div
          className="fixed inset-0 z-0"
          onClick={() => setShowPicker(false)}
        ></div>
      )}
    </div>
  )
}

ColorPicker.propTypes = {
  color: PropTypes.string.isRequired,
  onColorChange: PropTypes.func.isRequired,
}

export default ColorPicker